import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { Avatar, vc } from "./common";
import { Coins } from "lucide-react";

const PRESETS = [1, 5, 10, 25];

export function TipModal({ open, onClose, recipient, refType, refId, onDone }) {
  const [amount, setAmount] = useState(5);
  const [custom, setCustom] = useState("");
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) { api.get("/wallet").then(({ data }) => setWallet(data)).catch(() => {}); setAmount(5); setCustom(""); }
  }, [open]);

  const amt = custom ? parseFloat(custom) || 0 : amount;
  const after = wallet ? wallet.available - amt : null;

  const send = async () => {
    if (amt <= 0) return toast.error("Enter a valid amount");
    setLoading(true);
    try {
      await api.post("/tip", { to_user: recipient.id, amount: amt, ref_type: refType, ref_id: refId });
      toast.success(`Tipped ${amt} VC to ${recipient.display_name}`);
      onDone && onDone();
      onClose();
    } catch (e) { toast.error(errText(e)); }
    finally { setLoading(false); }
  };

  if (!recipient) return null;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="glass border-white/10 sm:max-w-md" data-testid="tip-modal">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Coins className="text-gold" size={20} /> Send VirtuCoins</DialogTitle><DialogDescription className="sr-only">Send VirtuCoins to this creator</DialogDescription></DialogHeader>
        <div className="flex items-center gap-3 p-3 surface-2 rounded-xl">
          <Avatar src={recipient.avatar_url} name={recipient.display_name} size={44} />
          <div><div className="font-semibold">{recipient.display_name}</div><div className="text-xs text-muted-foreground">@{recipient.username}</div></div>
        </div>
        <div className="grid grid-cols-4 gap-2">
          {PRESETS.map((p) => (
            <button key={p} data-testid={`tip-preset-${p}`} onClick={() => { setAmount(p); setCustom(""); }}
              className={`py-3 rounded-xl font-mono text-sm border transition-colors ${!custom && amount === p ? "bg-gold text-black border-transparent" : "surface-2 border-white/10 hover:border-gold/50"}`}>
              {p} VC
            </button>
          ))}
        </div>
        <Input type="number" placeholder="Custom amount" value={custom} onChange={(e) => setCustom(e.target.value)}
          className="surface-2 border-white/10" data-testid="tip-custom-input" />
        <div className="flex justify-between text-sm px-1">
          <span className="text-muted-foreground">Balance after</span>
          <span className={`font-mono ${after != null && after < 0 ? "text-destructive" : "text-silver"}`}>{wallet ? vc(after) : "—"} VC</span>
        </div>
        <Button className="btn-gold w-full h-11 rounded-xl" disabled={loading || (after != null && after < 0)} onClick={send} data-testid="tip-confirm-btn">
          {loading ? "Sending…" : `Tip ${amt} VC`}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
